import React, { useState } from "react";
import { Button, Image } from "react-bootstrap";
import { Toggle } from "../../../superAdminReusable/reusableSuperAdminButton/Toggle";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import GlobalCatalogViewDetails, {
  GlobalCatalogDeletePopUp,
} from "../GlobalCatalogViewDetails";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP } from "../../../../../store/types";
import { ITEMTYPEVEG } from "../../../../../enums/OrderEnums";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

function ItemsDash(props) {
  return (
    <tr>
      <th className="f11-500" style={{ width: "14%" }}>
        Item ID
      </th>
      <th className="f11-500" style={{ width: "20%" }}>
        Item Name
      </th>
      <th className="f11-500" style={{ width: "15%" }}>
        Item
        <br />
        Category
      </th>
      <th className="f11-500" style={{ width: "18%" }}>
        Status
      </th>
      <th className="f11-500" style={{ width: "18%" }}>
        Created Date & <br />
        Time
      </th>
      <th className="f11-500" style={{ width: "15%" }}>
        Actions
      </th>
    </tr>
  );
}

export default ItemsDash;

export function ItemsBody(props) {
  const dispatch = useDispatch();
  let history = useHistory();
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const takeToEditPage = (itemId) => {
    dispatch({ type: SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP, payload: itemId });
    if (props.type === "chain") {
      history.push("/superadmin-chain-catalogue/add-item");
    } else {
      history.push("/superadmin-global-catalogue/add-item");
    }
  };
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      {/* {console.log(props && props.item && props.item)} */}
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className="sd_body_table-row"
                // style={{ textAlign: "center" }}
                onClick={showTr}
              >
                <td style={{ width: "14%" }}>
                  <div className="f12-500 text-break">
                    #ID {props && props.item && props.item._id}
                  </div>
                  {/* {props && props.item && props.item.ext_id} */}
                  <br />
                  <SimpleReactLightbox>
                    <SRLWrapper options={options}>
                      {props?.item?.image_thumbnails &&
                      props?.item?.image_thumbnails[0] ? (
                        <img
                          src={props.item.image_thumbnails[0]}
                          width="42px"
                          height="42px"
                          style={{ borderRadius: "5px" }}
                        />
                      ) : props?.item?.images[0] ? (
                        <img
                          src={props.item.images[0]}
                          width="42px"
                          height="42px"
                          style={{ borderRadius: "5px" }}
                        />
                      ) : (
                        <img
                          src={require("../../../../../assets/images/Orders/Mask Group 113.png")}
                          width="42px"
                          height="42px"
                          style={{ borderRadius: "5px" }}
                        />
                      )}
                    </SRLWrapper>
                  </SimpleReactLightbox>
                </td>
                <td style={{ width: "20%" }}>
                  <div className="d-flex">
                    {ITEMTYPEVEG.map((type, index) => {
                      return (
                        <React.Fragment key={index}>
                          {props?.item?.itemType === type?.value ? (
                            <Image
                              width="20px"
                              src={type.url}
                              alt={type.title}
                              title={type.title}
                              className="vegIcon"
                              fluid
                            />
                          ) : null}
                        </React.Fragment>
                      );
                    })}

                    <div className="f12-500 ml-3">
                      {props && props.item && props.item.name}
                    </div>
                  </div>
                  {/* &nbsp; {props && props.item && props.item.name} */}
                  <hr className="mt-2 mb-2" />
                  <div className="d-flex">
                    <Image
                      src={
                        props &&
                        props.item &&
                        props.item.primary_food_type &&
                        props.item.primary_food_type.icon
                      }
                      alt="Food type"
                      title="Food type"
                      width="20px"
                      fluid
                    />{" "}
                    {/* {props &&
                    props.item &&
                    props.item.primary_food_type &&
                    props.item.primary_food_type.title} */}
                    <div className="f12-500 ml-3">
                      {" "}
                      {props &&
                        props.item &&
                        props.item.primary_food_type &&
                        props.item.primary_food_type.title}
                    </div>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-500">
                    {props &&
                      props.item &&
                      props.item.category &&
                      props.item.category.name}
                  </div>
                  {/* {props &&
                    props.item &&
                    props.item.category &&
                    props.item.category.name} */}
                </td>

                <td
                  style={{ width: "18%" }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  {/* No{" "} */}
                  <Toggle
                    checked={props.item && props.item.status}
                    toggleFunction={() => props.changeItemStatus()}
                    // toggleFunction={() =>
                    //   changeAutoAccept(props.item.auto_accept)
                    // }
                    // toggleFunction={toggleFunction}
                  />{" "}
                  {/* Yes */}
                </td>
                <td style={{ width: "18%" }} className="d-flex">
                  {/* {props && props.item && props.item.prepTime} */}
                  <div className="f12-500">
                    {moment(props && props.item && props.item.createdAt).format(
                      "Do MMMM YYYY"
                    )}{" "}
                    <br />
                    {moment(props && props.item && props.item.createdAt).format(
                      "hh:mm a"
                    )}
                  </div>
                </td>
                <td
                  style={{ width: "15%" }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <div className="d-flex">
                    {props.show === false ? (
                      <> </>
                    ) : (
                      <GlobalCatalogViewDetails
                        data={props && props.item}
                        types={props.type}
                      />
                    )}
                    {props.show === false ? (
                      <> </>
                    ) : (
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={() => takeToEditPage(props.item._id)}
                        // onClick={(e) => {
                        //   if (!e) var e = window.event;
                        //   e.cancelBubble = true;
                        //   if (e.stopPropagation) e.stopPropagation();
                        //   //   viewType(1);
                        //   //   viewOrderInDetail();
                        // }}
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    )}{" "}
                    <GlobalCatalogDeletePopUp
                      title="Remove Item"
                      subtitle="Are you sure you want to remove this item from catalogue?"
                      type="item"
                      deleteItem={() => props.deleteItem()}
                    />
                  </div>
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <tr
                  className="sd_accordion_body"
                  style={{ background: "#ffffff" }}
                >
                  {console.log(props.item)}
                  <div className="container-fluid mb-3">
                    <hr />
                    <div className="row">
                      <div className="col-3 f14-500">Description</div>
                      <div className="col-3 f14-500">Cuisine Type</div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-3 f12-500">
                        {props && props.item && props.item.description}
                      </div>
                      <div className="col-3 f12-500">
                        {props &&
                          props.item &&
                          props.item.cuisin_type &&
                          props.item.cuisin_type.title}
                      </div>
                    </div>
                  </div>
                </tr>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
}
